import src from "IMAGE";
export default { src, width: 385, height: 240, blurWidth: 0, blurHeight: 0};
